import * as React from 'react';
import { ConfirmContext } from './Provider';

export default function useConfirm() {
  const confirmContext = React.useContext(ConfirmContext);
  if (!confirmContext) {
    throw new Error('No GridItemContext.Provider found when calling useGridItemContext.');
  }

  const [confirm, setConfirm] = confirmContext;
  const [needsCleanup, setNeedsCleanup] = React.useState(false);

  const promptConfirm = (
    title: string,
    message: string,
    acceptText: string,
    rejectText: string,
  ) => {
    setNeedsCleanup(true);

    const promise = new Promise((resolve, reject) => {
      setConfirm({
        ...confirm,
        open: true,
        proceed: resolve,
        reject: reject,
        title: title,
        message: message,
        acceptText: acceptText,
        rejectText: rejectText,
      });
    });

    return promise.then(
      () => {
        setConfirm((prev) => {
          prev.open = false;
          return { ...prev };
        });
        return true;
      },
      () => {
        setConfirm((prev) => {
          prev.open = false;
          return { ...prev };
        });
        return false;
      },
    );
  };

  React.useEffect(() => {
    return () => {
      if (confirm.reject && needsCleanup) {
        confirm.reject();
      }
    };
  }, [confirm, needsCleanup]);

  return {
    ...confirm,
    promptConfirm,
  };
}
